var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Row',{staticClass:"expand-row"},[_c('Table',{staticStyle:{"width":"100%"},attrs:{"no-data-text":_vm.$t('common.noData'),"columns":_vm.columns,"data":_vm.securityData}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b4e178","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/resource_configuration_management/aws/route/TableExpand.vue
// module id = kSgJ
// module chunks = 0